import { PublicLayout } from "@/components/public/PublicLayout";
import { HeroSection } from "@/components/public/HeroSection";
import { BrandValues } from "@/components/public/BrandValues";
import { ExperienceGrid } from "@/components/public/ExperienceGrid";
import { GuestTestimonials } from "@/components/public/GuestTestimonials";
import { SEOHead } from "@/components/public/SEOHead";
import { useUiTranslations } from "@/hooks/use-ui-translations";

export default function Home() {
  const { t } = useUiTranslations();

  return (
    <PublicLayout fullBleed>
      <SEOHead
        title="Guestly Experiences — Curated Tours in Sweden"
        description="Discover handpicked kayaking, sauna, northern lights and cultural experiences across Sweden. Book instantly with local expert guides."
        path="/"
      />

      <HeroSection />
      <div className="pt-44 sm:pt-40" /> {/* Spacer for overlapping hero puff cards */}
      <BrandValues />

      <div className="mx-auto max-w-6xl px-4 py-12 pb-16">
        <h1 className="mb-8 text-3xl font-semibold tracking-tight text-foreground">
          {t("allExperiences.heading")}
        </h1>
        <ExperienceGrid />
      </div>

      <GuestTestimonials />
    </PublicLayout>
  );
}
